import React from 'react';
import { Link } from 'react-router-dom';

const WorkflowPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6">Workflow Optimization</h1>
      <p className="text-xl mb-8">
        Streamline your business processes and maximize efficiency with our intelligent workflow optimization solutions.
        Eliminate bottlenecks and automate repetitive tasks to boost productivity.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold mb-4">Optimization Features</h2>
          <ul className="space-y-3">
            <li>• Process mapping and analysis</li>
            <li>• Bottleneck identification</li>
            <li>• Task automation</li>
            <li>• Performance monitoring</li>
            <li>• Resource allocation optimization</li>
          </ul>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold mb-4">Business Impact</h2>
          <ul className="space-y-3">
            <li className="bg-custom-blue text-white px-4 py-2 rounded-md">• Increased operational efficiency</li>
            <li className="bg-custom-blue text-white px-4 py-2 rounded-md">• Reduced processing time</li>
            <li className="bg-custom-blue text-white px-4 py-2 rounded-md">• Lower operational costs</li>
            <li className="bg-custom-blue text-white px-4 py-2 rounded-md">• Improved employee productivity</li>
            <li className="bg-custom-blue text-white px-4 py-2 rounded-md">• Enhanced customer satisfaction</li>
          </ul>
        </div>
      </div>

      <div className="bg-gray-100 p-8 rounded-lg text-center">
        <h2 className="text-2xl font-semibold mb-4">Transform Your Workflows Today</h2>
        <p className="mb-6">
          Let us help you optimize your business processes for maximum efficiency and productivity.
        </p>
        <Link
          to="/contact"
          className="bg-custom-blue text-white px-8 py-3 rounded-lg hover:bg-opacity-90 transition-colors"
        >
          Get Started
        </Link>
      </div>
    </div>
  );
};

export default WorkflowPage; 